import { Avatar, AvatarGroup } from '@mui/material'
import { ICONE } from '@lucan/base-ui'
import { SITUAZIONE_DATI_CONDUCENTE } from 'pages/DatiConducente/utilDatiConducente'

export default function IconeConducenteProprietario(props) {
  const { situazione } = props

  const casoB = situazione === SITUAZIONE_DATI_CONDUCENTE.CASO_B
  const casoC = situazione === SITUAZIONE_DATI_CONDUCENTE.CASO_C

  return (
    <AvatarGroup sx={{ width: 'fit-content', margin: 'auto' }}>
      <Avatar sx={{ bgcolor: `${casoB ? 'error' : 'success'}.main` }}>
        {casoB ? <ICONE.VEICOLO_BARRATO /> : <ICONE.VEICOLO />}
      </Avatar>
      <Avatar sx={{ bgcolor: `${casoC ? 'error' : 'success'}.main` }}>
        {casoC ? <ICONE.CHIAVE_BARRATA /> : <ICONE.LOGIN />}
      </Avatar>
    </AvatarGroup>
  )
}